module.exports = __webpack_public_path__ + "static/media/f_glasses_cateye.f6175a1f.png";